import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../styles/FormInputFloating.module.scss';

const cx = classNames.bind(styles);

const EnrollmentFormInputFloating = ({
  name,
  type,
  label,
  imageLabel,
  placeholder,
  defaultValue,
  required,
  inputRef,
  watchInput,
  error,
  onChange,
}) => {
  return (
    <label className={cx('EnrollmentFormInputFloating', { withImage: imageLabel, visible: watchInput, error })}>
      <input
        name={name}
        type={type}
        placeholder={placeholder || label}
        defaultValue={defaultValue}
        ref={inputRef}
        onChange={onChange}
      />
      {imageLabel && (
        <div className={styles.inputImage}>
          <img alt={label} src={imageLabel} />
        </div>
      )}
      <span className={cx('floatingLabelText')}>
        {label}
        {required && <em> *</em>}
      </span>
    </label>
  );
};

EnrollmentFormInputFloating.defaultProps = {
  imageLabel: null,
  placeholder: null,
  defaultValue: null,
  required: false,
  watchInput: null,
  error: null,
  onChange: null,
};

const errorShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
});

EnrollmentFormInputFloating.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  imageLabel: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  inputRef: PropTypes.func.isRequired,
  watchInput: PropTypes.string,
  error: errorShape,
  onChange: PropTypes.func,
};

export default EnrollmentFormInputFloating;
